module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-73.3071792c.svg";